<template>
  <div>
    <v-col cols="12" md="4">
      <v-btn class="btn-save" @click="showConfiguration = true">Configuración de reportes contables</v-btn>
    </v-col>
    <v-dialog v-model="showConfiguration" max-width="60%" scrollable>
      <v-card>
        <v-card-title>
          <h3>Configuraciones contables</h3>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer" tag="form" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(addConfiguration)">
              <v-row class="mt-2" v-if="!showPlan">
                <v-col cols="6">
                  <ValidationProvider name="Representante legal nombre" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="LegalRepresentativeName"
                      :error-messages="errors " label="Representante legal nombre"
                      dense outlined required chips></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="LegalRepresentativeAdditional" label="Representante legal adicional" dense
                    outlined :persistent-hint="true" hint="Esto se mostrará despues del Representante legal nombre" chips></v-text-field>
                </v-col>
                <v-col cols="6">
                  <ValidationProvider name="Auditor nombre" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="AuditorName" label="Auditor nombre" dense outlined required
                      :error-messages="errors" chips></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="AuditorAdditional" label="Auditor adicional" dense outlined
                    :persistent-hint="true" hint="Esto se mostrará despues del Auditor nombre" chips></v-text-field>
                </v-col>
                <v-col cols="6">
                  <ValidationProvider name="Contador nombre" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="AccountantName" label="Contador nombre" dense outlined required
                      :error-messages="errors" chips></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="AccountantAdditional" label="Contador adicional" dense outlined
                    :persistent-hint="true" hint="Esto se mostrará despues del Contador nombre" chips></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-2" v-if="showPlan">
                <v-col cols="12">
                  Panilla de pagos BAC
                </v-col>
                <v-col cols="6">
                  <ValidationProvider name="Número de plan" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="PlanNumber" label="Número de plan" dense outlined required
                    :error-messages="errors" chips></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn class="btn-save" @click="$refs.observer.validate().then(isValid => isValid && addConfiguration())">
            <v-icon left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
      <block v-if="loading" />
    </v-dialog>
    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
  </div>
</template>
<script>
import Alerts from '@/components/Alerts'
import Vuex from '../../../../store';

export default {
  name: "ManageAccountingReport",
  components: {
    Alerts,
  },
  props: {
    win: {
      type: Object,
      required: false,
      default: null
    },
    businessData: {
      type: Object,
      required: false,
      default: null
    },
    autoOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    showPlan: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showConfiguration: false,
      business: null,
      LegalRepresentativeName: '',
      LegalRepresentativeAdditional: '',
      AuditorName: '',
      AuditorAdditional: '',
      AccountantName: '',
      AccountantAdditional: '',
      PlanNumber: '',
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
    }
  },
  mounted() {
    this.initializeData();
    if (this.autoOpen) {
      this.showConfiguration = true;
    }
  },
  watch: {
    showConfiguration(newVal) {
      if (!newVal) {
        this.$emit('dialog-closed');
      }
    }
  },
  methods: {
    closeDialog() {
      this.showConfiguration = false;
    },
    initializeData() {
      // Priorizar businessData prop, luego win.meta.business, finalmente localStorage
      const userData = JSON.parse(localStorage.getItem("user")) || {};
      
      if (this.businessData) {
        this.business = this.businessData;
      } else if (this.win && this.win.meta && this.win.meta.business) {
        this.business = this.win.meta.business;
      } else if (userData) {
        // Usar datos del localStorage si no hay business data disponible
        // Usar businessid que es el ID numérico, no business que es el nombre
        this.business = { ID_Business: userData.businessid };
      }

      // Inicializar campos del formulario
      this.LegalRepresentativeName = userData.LegalRepresentativeName ?? '';
      this.LegalRepresentativeAdditional = userData.LegalRepresentativeAdditional ?? '';
      this.AuditorName = userData.AuditorName ?? '';
      this.AuditorAdditional = userData.AuditorAdditional ?? '';
      this.AccountantName = userData.AccountantName ?? '';
      this.AccountantAdditional = userData.AccountantAdditional ?? '';
      this.PlanNumber = userData.PlanNumber ?? '';
    },
    logout() {
      const confKeys = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("conf_")) {
          confKeys.push({
            key,
            value: localStorage.getItem(key),
          });
        }
      }
      // this.delete_cookie('details')
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("customizeOptions");
      localStorage.removeItem("branch");

      Vuex.commit("setToken", null);
      Vuex.commit("setUser", null);
      Vuex.commit("setCustomizeOptions", null);
      Vuex.commit("RESTART_STATE", null);
      localStorage.clear();
      confKeys.forEach(({ key, value }) => {
        localStorage.setItem(key, value);
      });
      this.$router.push("/login");
    },
    closeAlert() {
      this.alert.show = false;
      if (this.alert.options == "reload") {
        this.$store.dispatch('reloadData', 'business');
      }
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options == "Deletebussiness") {
        this.deleteBusiness();
      }
      else if (this.alert.options == "reload") {
        this.$store.dispatch('reloadData', 'business');
      }
      else if (this.alert.options == "newWindow") {
        if (this.win && this.win.uuid) {
          this.$store.dispatch('deleteWindowByUuid', { uuid: this.win.uuid });
        }
        this.$store.dispatch('reloadData', 'business');
      }
      if (this.alert.options == "closeSesion") {
        this.logout();
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    async addConfiguration() {
      this.loading = true;
      const isValid = await this.$refs.observer.validate();
      if (isValid === false) {
        this.loading = false;
        this.showAlert(
          "error",
          "Error",
          "Tienes que completar todos los campos para iniciar sesión"
        );
        return;
      }
      let formdata = new FormData();
      formdata.append('business', JSON.stringify({
        LegalRepresentativeName: this.LegalRepresentativeName,
        LegalRepresentativeAdditional: this.LegalRepresentativeAdditional,
        AuditorName: this.AuditorName,
        AuditorAdditional: this.AuditorAdditional,
        AccountantName: this.AccountantName,
        AccountantAdditional: this.AccountantAdditional,
        PlanNumber: this.PlanNumber,
      }));
      this.$API.business.updateBusiness(formdata, this.business.ID_Business)
        .then(() => {
          this.showAlert("closeeSesion", "exito ", "Se han modificado datos al negocio.Para que los cambios surtan efecto debe cerrar sesion", 'closeSesion');
          this.$emit('configuration-updated', {
            LegalRepresentativeName: this.LegalRepresentativeName,
            LegalRepresentativeAdditional: this.LegalRepresentativeAdditional,
            AuditorName: this.AuditorName,
            AuditorAdditional: this.AuditorAdditional,
            AccountantName: this.AccountantName,
            AccountantAdditional: this.AccountantAdditional,
            PlanNumber: this.PlanNumber,
          });
        })
        .catch(() => {
          this.showAlert("danger", "Error", "Error al actualizar los datos", "reload");
        })
        .finally(() => {
          this.loading = false;
          this.showConfiguration = false;
        });
    },
  }
};
</script>
